import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { Col, Container, Row } from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import InfiniteScroll from "react-infinite-scroll-component";
import { IconeCarregar } from "../../comum/components/Icones";
import CardAnaliseCritica from "./CardAnaliseCritica";
import { HeaderTableFixed } from "./../../../utils/headerTableFixed";


@inject("store")
@observer
export class TabelaAnaliseCritica extends Component {
    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;
        this.controller = this.props.controller;
        window.addEventListener('scroll', HeaderTableFixed);
    };

    render() {

        return (
            <Container fluid className="tabela-container">
                {(!this.controller.analiseLista.length > 0)
                    ? <Row>
                        <Col xs={12}>
                            {
                                this.controller.loading
                                    ? <IconeCarregar tamanho="2x" />
                                    : <span className="mensagem-filtrar">
                                        {this.controller.tableMessage}
                                    </span>
                            }
                        </Col>
                    </Row>
                    :

                    <InfiniteScroll
                        dataLength={this.controller.items.length}
                        next={() => this.controller.loadNextTurn()}
                        hasMore={this.controller.hasMore}
                        loader={<IconeCarregar tamanho="2x" />}
                    >
                        <ToolkitProvider
                            keyField="AnaliCritId"
                            data={[...this.controller.items]}
                            columns={[...this.controller.colunas]} >
                            {props => (
                                <div id="tableHeaderFixed">
                                    {window.innerWidth > 991
                                        ? <BootstrapTable bootstrap4
                                            striped
                                            bordered={false}
                                            noDataIndication={() => this.controller.noData}
                                            classes="tabela tabela-layout analise-critica"
                                            onScroll={() => this.scrolling}
                                            {...props.baseProps} />
                                        : <Row>
                                            {this.controller.items.map((card, x) => (
                                                <CardAnaliseCritica
                                                    key={x}
                                                    controller={this.controller}
                                                    data={card}
                                                    colunas={[...this.controller.colunas]}
                                                />
                                            ))}
                                        </Row>
                                    }
                                </div>)
                            }
                        </ToolkitProvider>
                    </InfiniteScroll>}

            </Container>
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/analise/components/TabelaAnaliseCritica.js